// extracted by mini-css-extract-plugin
export default {"inputs":"SectionForm_inputs__tLMNi","actions":"SectionForm_actions__hoqdu"};